import React from "react"
import { Field } from "redux-form"
import FieldSet from "@infotech/uikit-fieldset"
import { Flex } from "@infotech/uikit-grid"
import TimeDurationPicker from "src/components/TimeDurationPicker"
import DateTimePicker from "src/components/DateTimePicker"
import { P } from "@infotech/uikit-text"
import { secondsToDaysHoursMinutes } from "src/containers/EventType"
import cn from "classnames"
import styles from "./styles.css"

const DurationStatus = ({
  hasEvent,
  executionTime,
  minExecutionTime,
  maxExecutionTime,
}) => (
  <>
    <P
      className={cn(styles[`duration-caption`], {
        [styles[`warning-duration-caption`]]:
          (minExecutionTime && executionTime < minExecutionTime) ||
          (maxExecutionTime && executionTime > maxExecutionTime),
      })}
    >
      {(hasEvent &&
        (minExecutionTime || maxExecutionTime
          ? `Может быть ${
              minExecutionTime
                ? `от ${secondsToDaysHoursMinutes(minExecutionTime)}`
                : ``
            }
          ${
            maxExecutionTime
              ? `до ${secondsToDaysHoursMinutes(maxExecutionTime)}`
              : ``
          }`
          : `Длительность события не ограничена`)) ||
        ``}
    </P>
  </>
)

export default ({
  startDateTime,
  endDateTime,
  startCaption,
  endCaption,
  durationCaption,
  minExecutionTime,
  maxExecutionTime,
  executionTime,
  eventTypeId,
  isOnlyDateType,
  noError,
  getTestAttribute,
  isDisabled,
  isDisabledStart,
  isDisabledEnd,
  onDurationChange,
  // Необязательные, кастомные хендлеры изменений
  onStartDateTimeChange,
  onEndDateTimeChange,
}) => (
  <div>
    <Flex column>
      <FieldSet caption={startCaption || `Начало события`} required>
        <div data-testid={getTestAttribute(`startDateTime`)}>
          <Field
            component={DateTimePicker}
            name="startDateTime"
            props={{
              withTime: !isOnlyDateType,
              isDisabled: isDisabled || isDisabledStart,
            }}
            {...(onStartDateTimeChange
              ? { onChange: onStartDateTimeChange }
              : {})}
          />
        </div>
      </FieldSet>
      <FieldSet
        caption={durationCaption || `Длительность события`}
        className={styles.NoBottomPadding}
        required
      >
        <TimeDurationPicker
          value={executionTime}
          onChange={onDurationChange}
          noError={noError}
          getTestAttribute={getTestAttribute}
          isDisabled={isDisabled || isDisabledEnd}
          isHoursDisabled={isOnlyDateType}
          isMinutesDisabled={isOnlyDateType}
        />
        <DurationStatus
          hasEvent={eventTypeId}
          executionTime={executionTime}
          minExecutionTime={minExecutionTime}
          maxExecutionTime={maxExecutionTime}
        />
      </FieldSet>
      <FieldSet caption={endCaption || `Окончание события`} required>
        <div data-testid={getTestAttribute(`endDateTime`)}>
          <Field
            component={DateTimePicker}
            name="endDateTime"
            props={{
              isDisabled: isDisabled || isDisabledEnd,
              withTime: !isOnlyDateType,
              duration: endDateTime - startDateTime,
            }}
            {...(onEndDateTimeChange
              ? { onChange: onStartDateTimeChange }
              : {})}
          />
        </div>
      </FieldSet>
    </Flex>
  </div>
)
